import { useState, useEffect } from 'react';

/**
 * Fetch AI coaching recommendations for shot groups
 * @param {Array} shotGroups - Shot groups to analyze
 * @returns {Object} { tips, presets, loading }
 */
export const useAIRecommendations = (shotGroups) => {
  const [tips, setTips] = useState([]);
  const [presets, setPresets] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTips = async () => {
      try {
        const allShots = shotGroups.flatMap(g =>
          g.shots.filter(s => s.included).map(s => ({
            ball_speed: s.metrics.ballSpeed,
            launch_angle: s.metrics.launchAngle,
            spin_rate: s.metrics.spinRate,
            spin_axis: s.metrics.spinAxis,
            attack_angle: s.metrics.attackAngle,
            carry_distance: s.metrics.carry,
            offline_distance: s.metrics.offlineDistance
          }))
        );

        const response = await fetch('/api/coach/analyze', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ shots: allShots, goal: 'distance' })
        });

        if (!response.ok) throw new Error('Coach analysis failed');

        const data = await response.json();
        setTips(data.tips);
        setPresets(data.presets);
      } catch (error) {
        console.error('Failed to fetch coaching tips:', error);
      } finally {
        setLoading(false);
      }
    };

    if (shotGroups && shotGroups.length > 0) {
      fetchTips();
    }
  }, [shotGroups]);

  return { tips, presets, loading };
};
